import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedVideos() {
  const featuredArticles = articles.slice(0, 6);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              精选视频推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              编辑团队精心挑选的高质量鲍鱼知识视频
            </p>
          </div>
          <Link
            to="/category/yangzhi"
            onClick={handleClick}
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              onClick={handleClick}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer border border-background-200/60 transition-all hover:border-primary-200"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute bottom-3 right-3 bg-black/70 backdrop-blur-sm text-background-50 text-xs px-2 py-1 rounded-md flex items-center gap-1">
                  <i className="ri-play-fill text-xs"></i>
                  {article.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{article.views.toLocaleString()} 次观看</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}